export function createEmptyDocumentClient() {
    return {
        pageHaveChange: 0,
        name: '',
        clientEmail: '',
        phone: '',
        cell: '',
        contact: '',
        fax: '',
        pager: '',
        website: '',
        billingAddressLine1: '',
        billingAddressLine2: '',
        billingAddressLine3: '',
        shippingName: '',
        shippingAddressLine1: '',
        shippingAddressLine2: '',
        shippingAddressLine3: '',
        itemDiscount: 0,
        itemDiscountAsPercent: 0,
        note: '',
        innerUUID: ''
    };
}
